'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _injectable = require('./injectable');

var _injectable2 = _interopRequireDefault(_injectable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Factory = function (_Injectable) {
  _inherits(Factory, _Injectable);

  function Factory() {
    _classCallCheck(this, Factory);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Factory).apply(this, arguments));
  }

  _createClass(Factory, [{
    key: 'create',
    value: function create() {
      throw Error('Factory#create() must be implemented');
    }
  }]);

  return Factory;
}(_injectable2.default);

exports.default = Factory;
//# sourceMappingURL=factory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-ecmascript/dist/module-helpers/factory.js
// module id = 629
// module chunks = 0